import React from "react";

const ContactSection = ({ email = "hello@propagedigital.com" }) => {
  return (
    <section className="bg-background dark:bg-gray-900 text-text dark:text-white py-16 sm:py-20 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1200px] px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left copy */}
          <div>
            <span className="inline-block text-xs font-semibold px-3 py-1 rounded-full border border-border dark:border-gray-700 bg-surface dark:bg-gray-800 transition-colors duration-300">
              Contact Mr Reel
            </span>

            {/* One-line heading */}
            <h1 className="mt-4 text-4xl sm:text-6xl font-extrabold leading-tight whitespace-nowrap dark:text-white transition-colors duration-300">
              About Mr Reel
            </h1>

            {/* Supporting text */}
            <p className="mt-4 max-w-2xl text-text/70 dark:text-white/80 transition-colors duration-300">
              We review casinos, bonuses, and payment methods with a focus on
              clarity and player trust. If you’re a partner or reader with a
              question, we’d love to hear from you.
            </p>
            <p className="mt-3 max-w-2xl text-text/70 dark:text-white/80 transition-colors duration-300">
              Share a bit about your request—press, partnerships, or general
              feedback—and we’ll point you in the right direction.
            </p>
          </div>

          {/* Right contact card (email only) */}
          <div className="lg:justify-self-end w-full">
            <div className="rounded-2xl border border-border dark:border-gray-700 bg-surface dark:bg-gray-800 text-text dark:text-white shadow-md p-6 sm:p-7 transition-colors duration-300">
              <p className="text-sm text-text/80 dark:text-white/80 mb-2 transition-colors duration-300">
                Prefer email?
              </p>
              <a
                href={`mailto:${email}`}
                className="block text-xl sm:text-2xl font-semibold no-underline break-words dark:text-white transition-colors duration-300"
              >
                {email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
